import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import { Heading } from '../../components/Heading';
import MetalStreamForm from '../../components/MetalStreamForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import { useMetalStreamData } from '../../hooks/useMetalStreamData';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { metalStreamDataHelper } from '../../util/helpers/metalStreamDataHelper';

const MetalStreamSilver = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { MetalStreamData } = useMetalStreamData();
  const goldPercentage = metalStreamDataHelper(
    MetalStreamData,
    'GoldPercentage',
  );
  const { BrokerName } = useSelector(selectSettings);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={
        goldPercentage ? activeItem?.previousPath : activeItem?.preSkipPath
      }
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagSilver', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={12}>{t('metalstream.silverTitle')}</Heading>
      <Paragraph mb={16} color={themeColors.colorTextXLLight}>
        {t('metalstream.silverSubtitle')}
      </Paragraph>
      <MetalStreamForm
        productType="Silver"
        nextPath={activeItem?.nextPath}
        skipStepPath={activeItem?.skipPath}
      />
    </OnBoardingContainer>
  );
};

export default MetalStreamSilver;
